import { PropsWithChildren, memo, useCallback, useRef } from 'react';
import classes from './styles.module.css';
import { useWindowSize } from 'react-easyrocket';
import { useModalContext } from 'src/hooks/useModalContext';
import { twJoin, twMerge } from 'tailwind-merge';
import CloseModal from './components/CloseModal';

function _ModalWrapper({
  onClose,
  children,
  className,
  containerClassName,
  isTransparentBg,
  showCross = true
}: PropsWithChildren<{
  onClose?: () => void;
  className?: string;
  containerClassName?: string;
  isTransparentBg?: boolean;
  showCross?: boolean;
}>) {
  const { openedModalName, modalProps, closeModal } = useModalContext<{
    onClose?: () => void;
  }>();
  const { isMobileLayout, isLandscape } = useWindowSize();
  const contentRef = useRef<HTMLDivElement | null>(null);

  const handleClose = useCallback(() => {
    closeModal(); // основная функция которая закрывает модальное окно в контексте модальных окон
    onClose?.(); // функция переданная из компонента конкретного модального окна
    modalProps?.onClose?.(); // функция-коллбэк переданная в момент открытия модального окна
  }, [closeModal, modalProps, onClose]);

  return (
    <div
      data-role="blackBackgroundFullscreenPlaceholder"
      className={twMerge(
        'flex items-center justify-center left-0 top-0 fixed z-[900] w-screen h-full max-h-screen bg-m_shadow',
        openedModalName ? 'translate-y-0' : 'translate-y-[-100%]'
      )}>
      <div
        className={twMerge(
          'flex flex-col items-end max-w-[90%] max-h-[90%] overflow-y-hidden rounded-b-[20px]',
          isLandscape && isMobileLayout && 'flex-row-reverse items-start h-full',
          className
        )}>
        {showCross && (
          <CloseModal
            onClose={handleClose}
            className={twJoin('flex-shrink-0 ml-2 mb-2', classes['cross'])}
          />
        )}
        <div
          ref={contentRef}
          key="modalContentWrapper"
          data-role="modalContentWrapper"
          className={twMerge(
            'modal-wrapper max-h-full w-full h-auto overflow-y-auto overflow-x-hidden rounded-[20px] self-center',
            !isTransparentBg ? 'bg-lm_bg shadow-xl' : 'bg-opacity-0',
            containerClassName
          )}>
          {children}
        </div>
      </div>
    </div>
  );
}

export const ModalWrapper = memo(_ModalWrapper);
